<template>
<div>
  <product-card />
  <vx-card title="填写下单信息">
    <vx-form class="w-full" layout="v" label-align="top" v-slot="{invalid, handleSubmit}">
      <form-item required label="二维码数量" :help="form.printing ? '请填写您需要的标签数量' : '请填写需要的二维码数量'">
        <div class="inline-block w-48 ">
        <vs-input v-model="form.number" />
        </div>
      </form-item>
      <form-item required label="二维码有效期" :help="'请根据产品有效期选择二维码有效期'">
        <v-select v-model="form.qrExpire" placeholder="请选择有效期" :options="qrExpire" :reduce="v => v.id" label="label"></v-select>
      </form-item>
      <form-item label="是否需要印刷服务" label-align="none" help="您是否需要印刷标签，如果不需要，您购买后可下载指定数量的溯源二维码，如果需要，我们将为您印刷好标签后邮寄给您">
        <vs-checkbox v-model="form.printing"><span>需要</span></vs-checkbox> 
      </form-item>
      <div v-if="form.printing">
        <form-item required label="标签尺寸" help="请选择您需要的标签尺寸">
          <v-select v-model="form.size" placeholder="请选择尺寸" :options="size" :reduce="v => v.id" label="label">
            <template v-slot:option="opt">
              <div class="flex">
                <span>{{opt.shape}} {{opt.width}}CM * {{opt.height}}CM</span>
              </div>
            </template>
          </v-select>
        </form-item>
        <form-item required label="标签材质" help="请选择您需要的标签材质">
          <v-select v-model="form.material" placeholder="请选择材质" :options="material" :reduce="v => v.id" label="label"></v-select>
        </form-item>
        <form-item required label="标签样式" help="请选择您需要的标签样式">
          <vs-images hover="scale" v-model="form.style">
            <div v-for="img in style" class="vs-image-item" :class="{'bg-primary text-white': form.style === img.id}" @click="() => form.style = img.id">
              <vs-image class="img-item" :src="img.picture" />
              <div class="img-title">{{img.shape}}</div>
            </div>
            <div class="vs-image-item custom-img" :class="{'bg-primary text-white': form.style === -1}" @click="() => form.style = -1">
              <vs-image class="img-item" :src="require('@/assets/images/elements/custom.png')"/>
              <div class="img-title">定制化</div>
            </div>
          </vs-images>
        </form-item>
        <form-item v-if="form.style === -1" label="样式样本示例" help='
        您选择了定制化样式，您可以先上传您的样本或者标签设计稿，我们会使用通过线下方式与您取得联系<br />
        或者您也可以直接联系我们的客服<br />
        <br />
        公司名称: 常安不干胶彩印有限公司 <br />
        客服梁经理QQ：1973277844 <a class="inline" target=blank href=tencent://message/?uin=1973277844&Site=智慧溯源&Menu=yes><img border="0" SRC=http://wpa.qq.com/pa?p=1:1973277844:10 alt="点击这里给我发消息"></a><br />
        图稿翟小姐QQ:1060364536 <a class="inline" target=blank href=tencent://message/?uin=1060364536&Site=智慧溯源&Menu=yes><img border="0" SRC=http://wpa.qq.com/pa?p=1:1973277844:10 alt="点击这里给我发消息"></a><br />
        商务李小姐QQ:81650225 <a class="inline" target=blank href=tencent://message/?uin=81650225&Site=智慧溯源&Menu=yes><img border="0" SRC=http://wpa.qq.com/pa?p=1:1973277844:10 alt="点击这里给我发消息"></a><br />
'>
          <upload
            fileName="file"
            v-model="form.sample"
            data-vv-name="installer"
            automatic
            text="上传"
            accept=".jpg,.png"
            action="/admin/v1/file/upload"
            :single-upload="true"
            :limit="1"
          />
        </form-item>


        <!-- <form-item required label="标签材料" >
          <v-select  v-model="form.size" />
        </form-item> -->
        <vs-row>
          <vs-col class="w-full sm:text-right sm:w-1/4 mb-5"><b>收货地址</b></vs-col>
        </vs-row>
        <form-item required label="联系人">
          <vs-input class="w-full" v-model="form.contactName" />
        </form-item>
        <form-item required label="联系电话">
          <vs-input class="w-full" v-model="form.contactPhone" />
        </form-item>
        <form-item required label="收货地址">
          <vs-input class="w-full" v-model="form.address" />
        </form-item>
      </div>
      <form-item label="订单备注">
        <vs-textarea class="w-full" v-model="form.comment" />
      </form-item>

      <form-item label="价格"  label-align="none" :help="isValidChannel ? '您是我们的渠道商，享有价格优惠' : ''">
        <span class="text-danger text-lg">
          <span v-if="!price">-</span>
          <span v-else>￥{{price && price.toFixed(2)}}元</span>
        </span>
        <span class="text-sm ml-5 line-through" v-if="price && isValidChannel">
          原价: ￥{{originPrice.toFixed(2)}}元
        </span>
      </form-item>
      
      <form-item>
        <vs-button class="mr-3 mb-2" :disabled="invalid" @click="handleSubmit(submitForm)">提交</vs-button>
        <vs-button color="warning" type="border" class="mb-2" :to="'/batchno/detail/' + $route.params.batchID">返回</vs-button>
      </form-item>
    </vx-form>
  </vx-card>
</div>
</template>
<script>
import ProductCard from './product-card'
import _ from 'lodash'

const minNum = 5000 // 需要标签的最小数量
export default {
  components: {
    ProductCard,
  },
  data() {
    return {
      form: {
        number: minNum,
        printing: true,
        shape: '',
        size: 0,
        contactName: '',
        contactPhone: '',
        address: '',
        style: 0,
      },
    }
  },
  $computed: {
    style: 'dict.price.style',
    sticky: 'dict.price.sticky',

  },
  computed: {
    shape() {
      return _.uniq(this.sticky.map(i => i.shape))
    },
    size() {

      return this.sticky.map(i => ({
        ...i,
        label: `${i.width}CM x ${i.height}CM`
      }))
    },
    qrExpire() {
      return this.$s.dict.price.qrExpire.map(i => ({
        ...i,
        label: i.name
      }))
    },
    material() {
      return this.$s.dict.price.material.map(i => ({
        ...i,
        label: i.name
      }))
    },
    price() {
      return this.calPrice(this.qr)
    },
    originPrice() {
      return this.calPrice(this.$s.dict.price.qr || [])
    },
    isValidChannel() {
      return this.$s.auth.isChannel(this.$s.auth.user) && !this.$s.auth.isChannelOutofdate(this.$s.auth.user)
    },
    qr() {
      return this.isValidChannel ? this.$s.dict.price.channelQr : this.$s.dict.price.qr
    },
  },
  async mounted() {
    this.form.printing = this.$s.auth.user.roleID == 5
    // this.$s.user.getCompany()
    const contact = await this.$s.user.getContact()
    this.$nextTick(() => {
      this.form.contactName = contact.name
      this.form.contactPhone = contact.phone
      this.form.address = contact.address
      this.$forceUpdate()
    })
  },
  methods: {
    calPrice(qrPrice) {
      let num = this.form.number // 数量
      if (this.form.printing) {
        if (num < minNum) {
          num = minNum
        }
      }

      const qr = qrPrice.find(i => i.min <= num && (i.max > num || i.max == 0))
      let singleQr = qr.price // 二维码单价
      if (!this.isValidChannel) {
        const qrExpire = this.qrExpire.find(i => i.id == this.form.qrExpire)
        if (!qrExpire) {
          return 0
        }
        singleQr += + qrExpire.price
      }
      if (!this.form.printing) {
        return num * singleQr // 不需要印刷标签
      }
      if (num < minNum) {
        num = minNum
      }
      if (!this.form.size) {
        return 0
      }
      const sticky = this.sticky.find(i => i.id == this.form.size)
      if (!sticky) {
        return 0
      }
      const material = this.material.find(i => i.id == this.form.material)
      if (!material) {
        return 0
      }
      const singleSticky = sticky.price * material.price // 标签单价
      return (singleQr + singleSticky) * num
    },
    async submitForm() {
      const data = {
        batchID: Number(this.$route.params.batchID),
        amount: parseInt(this.price * 100),
        number: Number(this.form.number),
        printing: this.form.printing,
        stickyID: Number(this.form.size),
        styleID: Number(this.form.style),
        sample: this.form.sample,
        contactName: this.form.contactName,
        contactPhone: this.form.contactPhone,
        address: this.form.address,
        comment: this.form.comment,
        qrExpire: this.form.qrExpire,
        material: this.form.material,
      }

      const {order} = await this.$s.order.create(data).catch(err => {
        this.$notify({
          color: 'danger',
          title:"下单失败",
          text: '服务器出错了，请稍后再试',
        })
        throw err
      })
      this.$notify({
        title: '已成功下单',
        text: '请在10分钟内完成付款'
      })
      this.$router.push('/order/pay/' + order.orderid)
    }
  }
}
</script>
<style lang="scss">
  .vs-image-item {
    &.bg-primary {
      .vs-image--img {
        background-color: rgba(var(--vs-primary), 1) !important;
      }
    }
    &.active {
      background: #f00;
    }
    width: calc(25% - 5px);
    margin: 5px;
    background: #fff;
    background-repeat: no-repeat;
    overflow: hidden;
    .img-item {
      width: 98%;
      .vs-image--img {
        background-repeat: no-repeat;
      }
    }
    &.custom-img {
      .img-item {
        background: #fff;
      }
    }
    .img-title{
      text-align: center;
    }
  }
</style>